import React, {useEffect, useRef, useState, useMemo} from 'react'
import Modal from 'react-bootstrap/Modal'
import {KTCard, KTIcon, KTCardBody, useDebounce} from '../../../../_metronic/helpers'
import {ColumnInstance, Row, useTable} from 'react-table'
import {useLayout} from '../../../../_metronic/layout/core'
import {Transaction, getTransactionDetails} from '../API/ViewTransactionsAPI'
import Select from 'react-select'
import Swal from 'sweetalert2'
import {useMatch, useNavigate} from 'react-router-dom'
import {Loader} from '../../product-master/loader'
import ViewLedgerModal from '../../product-master/ledger/ViewLedgerModal'

interface ViewTransactionModalProps {
  showViewTransactionModal: boolean
  setShowViewTransactionModal: React.Dispatch<React.SetStateAction<boolean>>
  transactionData: any
  ledgerData: any
  handleDelete: any
  showDeleteModal: boolean
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
}
const ViewTransactionModal: React.FC<ViewTransactionModalProps> = ({
  showViewTransactionModal,
  setShowViewTransactionModal,
  transactionData,
  ledgerData,
  handleDelete,
  showDeleteModal,
  setShowDeleteModal,
}) => {
  const navigate = useNavigate()
  const {company, financialYear} = useLayout()

  const [loading, setLoading] = useState(false)
  // const [transactionDetails, setTransactionDetails]: any = useState()
  const [ledgerOptions, setLedgerOptions]: any = useState(null)
  const [selectedLedger, setSelectedLedger]: any = useState(null)
  const [showLedgerDetailsModal, setShowLedgerDetailsModal] = useState(false)
  const [selectedLedgerDetails, setSelectedLedgerDetails] = useState<any>(null)

  const handleLedgerInfoClick = (ledgerId: string) => {
    const ledgerInfo = ledgerData[ledgerId]
    setSelectedLedgerDetails(ledgerInfo)
    setShowLedgerDetailsModal(true)
  }
  // console.log(transactionData)
  // console.log(ledgerData)

  const transactionDetails = {
    transactionId: transactionData.transactionId,
    voucherNumber: transactionData?.voucherNumber,
    voucherName: transactionData?.voucherType,
    voucherDate: transactionData?.voucherDate,
    transactingCurrency: transactionData?.currencyCode,
    voucherType: transactionData?.voucherType,
    narration: transactionData?.narration,
    transactionDetails: transactionData?.transactionItems?.map((item: any) => ({
      ledgerId: item.ledgerId,
      parentLedger: ledgerData[item.ledgerId]?.parentLedger,
      subLedger: ledgerData?.[item.ledgerId]?.subLedger,
      transactionAmount: item?.transactionAmount,
      transactionType: item?.transactionType,
      ledgerCode: ledgerData?.[item.ledgerId]?.ledgerCode,
    })),
    // Handle single advance item
    advanceDetails: transactionData?.advanceItem || null,
    // Handle single invoice item
    invoiceDetails: transactionData?.invoiceItem || null,
    // Handle against invoice array
    againstInvoiceDetails: transactionData?.againstInvoice || null,
    // Handle against advance array
    againstAdvanceDetails: transactionData?.againstAdvance || null,
  }

  // Set up ledger options for the dropdown
  useEffect(() => {
    if (transactionData.transactionItems) {
      const options = transactionData.transactionItems
        .filter(
          (item: any) =>
            transactionData?.advanceItem?.[item?.ledgerId] ||
            transactionData?.invoiceItem?.[item?.ledgerId]
        )
        .map((item: any) => ({
          label: ledgerData[item.ledgerId].parentLedger,
          value: item.ledgerId,
        }))
      setLedgerOptions(options)
      if (options.length > 0) {
        setSelectedLedger(options[0])
      }
    }
  }, [transactionData, ledgerData])
  console.log(selectedLedgerDetails)
  const selectedLedgerAdvanceDetails = transactionDetails.advanceDetails?.[selectedLedger?.value]
  // console.log(transactionDetails.againstInvoiceDetails)
  const selectedLedgerAgainstInvoiceDetails =
    transactionDetails.againstInvoiceDetails?.[selectedLedger?.value]

  const selectedLedgerAgainstAdvanceDetails =
    transactionDetails?.againstAdvanceDetails?.[selectedLedger?.value]

  const selectedLedgerInvoiceItemsDetails =
    transactionDetails.invoiceDetails?.[selectedLedger?.value]
  // console.log(transactionDetails)
  // console.log(ledgerOptions)
  console.log(selectedLedgerDetails)

  // let selectedLedgerAdvanceDetails =
  //   transactionDetails &&
  //   selectedLedger &&
  //   transactionDetails.advanceDetails.filter(
  //     (adv: any) => adv.ledger_code === selectedLedger.value
  //   )[0]
  // let selectedLedgerAgainstInvoiceDetails =
  //   transactionDetails &&
  //   selectedLedger &&
  //   transactionDetails.againstInvoiceDetails.filter(
  //     (adv: any) => adv.parent_ledger === selectedLedger.label
  //   )
  // console.log(selectedLedgerAgainstInvoiceDetails)
  return (
    <>
      <Modal
        show={showViewTransactionModal}
        fullscreen={true}
        onHide={() => setShowViewTransactionModal(false)}
        centered={true}
        // size='xl'
        contentClassName='position-relative top-0'
        dialogClassName='h-100'
      >
        <Modal.Header closeButton>
          <Modal.Title>Transaction Details</Modal.Title>
        </Modal.Header>
        {loading ? (
          <Loader height='80vh' />
        ) : (
          <>
            <Modal.Body>
              <KTCard className='py-4'>
                <div className='table-responsive'>
                  <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                    <thead>
                      <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                        <th>Voucher Number</th>
                        <th>Voucher Name</th>
                        <th>Voucher Date</th>
                        <th>Transacting currency</th>
                        <th className='w-300px'>Total Amount</th>
                        <th>NARRATION</th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600 fw-bold text-center'>
                      {transactionDetails?.transactionDetails?.map((tableData: any, index: any) => (
                        <React.Fragment key={index}>
                          {index === 0 && (
                            <tr className='text-center'>
                              <td>{transactionDetails.voucherNumber}</td>
                              <td className='text-capitalize'>{transactionDetails.voucherName}</td>
                              <td>{transactionDetails.voucherDate}</td>
                              <td>
                                <span className='badge badge-primary'>
                                  {transactionDetails.transactingCurrency}
                                </span>
                              </td>
                              <td>{tableData.transactionAmount}</td>
                              <td>{transactionDetails.narration || '-'}</td>
                            </tr>
                          )}
                          <tr className='text-center'>
                            <td colSpan={6} className='py-2'>
                              <div className='d-flex align-items-center justify-content-center gap-1'>
                                <button
                                  className='btn btn-icon btn-active-color-primary btn-sm'
                                  onClick={() => handleLedgerInfoClick(tableData.ledgerId)}
                                >
                                  <KTIcon iconName='information-5' className='fs-3' />
                                </button>
                                <span className='fw-bolder text-dark'>
                                  {tableData.parentLedger}
                                </span>
                                {tableData.subLedger && ` - ${tableData.subLedger}`}{' '}
                                <span
                                  className={
                                    tableData.transactionType === 'debit'
                                      ? 'text-danger'
                                      : 'text-success'
                                  }
                                  style={{fontStyle: 'italic'}}
                                >
                                  {transactionDetails.transactingCurrency}{' '}
                                  {tableData.transactionAmount}
                                  {tableData.transactionType === 'credit' ? ' CR' : ' DR'}
                                </span>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>

                {transactionDetails &&
                  transactionDetails.voucherType !== 'sales' &&
                  transactionDetails.voucherType !== 'purchase' && (
                    <div className='col-lg-5 mb-5'>
                      <div className='d-flex flex-row gap-5'>
                        <div className='col-6'>
                          <Select
                            value={selectedLedger}
                            onChange={setSelectedLedger}
                            options={ledgerOptions}
                            isSearchable={true}
                            components={{IndicatorSeparator: () => null}}
                            placeholder='Choose a Ledger (*)'
                          />
                        </div>
                      </div>
                    </div>
                  )}

                {selectedLedger && (
                  <>
                    <div className='col'>
                      <div className='d-flex justify-content-between align-items-center'>
                        <h3>
                          {transactionDetails.voucherType === 'Sales' ||
                          transactionDetails.voucherType === 'Purchase'
                            ? 'New Invoice'
                            : 'New Advance'}
                        </h3>
                      </div>
                      {transactionDetails.voucherType !== 'Sales' &&
                      transactionDetails.voucherType !== 'Purchase' ? (
                        selectedLedgerAdvanceDetails ? (
                          <div className='table-responsive'>
                            <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                              <thead>
                                <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                                  <th>Reference Number</th>
                                  <th>Date of Advance</th>
                                  <th>Amount</th>
                                  <th>Type</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody className='fw-bold text-gray-600'>
                                {selectedLedgerAdvanceDetails &&
                                  selectedLedgerAdvanceDetails.map((item: any) => (
                                    <tr className='text-center'>
                                      <td>{item.advanceNumber}</td>
                                      <td className='text-capitalize'>{item.advanceDate}</td>
                                      <td>{item.amount}</td>
                                      <td>
                                        <span className='badge badge-secondary'>
                                          {item.transactionType}
                                        </span>
                                      </td>
                                      {/* <td>{tableData.transactionAmount}</td> */}
                                      <td>{item.description || '-'}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className='my-5 p-5 fw-bolder fs-5 bg-light-primary rounded border border-dashed border-primary'>
                            No Advance
                          </div>
                        )
                      ) : selectedLedgerInvoiceItemsDetails ? (
                        <div className='table-responsive'>
                          <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                            <thead>
                              <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                                <th>Invoice Number</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Type</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody className='text-gray-600 fw-bold text-center'>
                              {selectedLedgerInvoiceItemsDetails &&
                                selectedLedgerInvoiceItemsDetails.map((item: any) => (
                                  <tr>
                                    <td>{item.invoiceNumber}</td>
                                    <td>{item.dueDate}</td>
                                    <td>{item.amount || 0}</td>

                                    <td>
                                      <span className='badge badge-secondary'>
                                        {item.transactionType}
                                      </span>
                                    </td>
                                    <td>{item.description || '-'}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className='my-5 p-5 fw-bolder fs-5 bg-light-primary rounded border border-dashed border-primary'>
                          No Invoice
                        </div>
                      )}
                    </div>

                    <div className='col mt-8'>
                      <div className='d-flex justify-content-between align-items-center'>
                        <h3>
                          {transactionDetails.voucherType === 'Sales' ||
                          transactionDetails.voucherType === 'Purchase'
                            ? 'Against Advance'
                            : 'Against Invoice'}
                        </h3>
                      </div>
                      {transactionDetails.voucherType !== 'Sales' &&
                      transactionDetails.voucherType !== 'Purchase' ? (
                        selectedLedgerAgainstInvoiceDetails ? (
                          <div className='table-responsive'>
                            <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                              <thead>
                                <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                                  <th>Invoice Number</th>
                                  <th>Date of Invoice</th>
                                  <th>Amount</th>
                                  <th>Settled Amount</th>
                                  <th>Set Off</th>
                                  <th>Type</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody className='text-gray-600 fw-bold text-center'>
                                {selectedLedgerAgainstInvoiceDetails.map(
                                  (invoice: any, index: any) => (
                                    <tr key={index} className='text-center'>
                                      <td>{invoice.invoiceNumber}</td>
                                      <td>{invoice.dueDate}</td>
                                      <td>{invoice.amount}</td>
                                      <td>{invoice.settledAmount || 0}</td>
                                      <td>{invoice.setOffAmount || 0}</td>
                                      <td>
                                        <span className='badge badge-secondary'>
                                          {invoice.transactionType}
                                        </span>
                                      </td>
                                      <td>{invoice.description || '-'}</td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className='my-5 p-5 fw-bolder fs-5 bg-light-primary rounded border border-dashed border-primary'>
                            No Invoice
                          </div>
                        )
                      ) : selectedLedgerAgainstAdvanceDetails ? (
                        <div className='table-responsive'>
                          <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                            <thead>
                              <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                                <th className='col-1.5'>Reference Number</th>
                                <th className='col-1.5'>Date of advance</th>
                                <th className='col-1.5'>Amount</th>
                                <th className='col-1.5'>Settled Amount</th>
                                <th className='col-1.5'>Set Off Amount</th>
                                <th className='col-1.5'>Type</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody className='text-gray-600 fw-bold text-center'>
                              {selectedLedgerAgainstAdvanceDetails.map(
                                (advance: any, index: any) => (
                                  <tr key={index} className='text-center'>
                                    <td>{advance.advanceNumber}</td>
                                    <td>{advance.advanceDate}</td>
                                    <td>{advance.amount}</td>
                                    <td>{advance.settledAmount || 0}</td>
                                    <td>{advance.setOffAmount || 0}</td>
                                    <td>
                                      <span className='badge badge-secondary'>
                                        {advance.transactionType}
                                      </span>
                                    </td>
                                    <td>{advance.description || '-'}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className='my-5 p-5 fw-bolder fs-5 bg-light-primary rounded border border-dashed border-primary'>
                          No Advance
                        </div>
                      )}
                    </div>
                  </>
                )}
              </KTCard>
            </Modal.Body>
            <Modal.Footer>
              {/* <button
             
              className={`btn btn-danger`}
              onClick={() => {
                setShowDeleteModal(true)
              }}
            >
              Delete Transaction
            </button>
            <button
             
              className='btn btn-primary'
              onClick={() =>
                navigate(`/transactions/enter/${transactionData.voucherType}`, {
                  state: {
                    transaction: transactionDetails,
                  },
                })
              }
            >
   
              Edit Transaction
            </button> */}
            </Modal.Footer>
          </>
        )}
      </Modal>
      {/* <Modal
        size='lg'
        className='modal-sticky modal-sticky-lg'
        id='ledger_details'
        data-backdrop='false'
        aria-hidden='true'
        show={showLedgerDetailsModal}
        animation={true}
      >
        <div className='modal-content'>
          <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
            <h5 className='fw-bold m-0'>Ledger Details</h5>
            <div className='d-flex ms-2'>
              <div
                className='btn btn-icon btn-sm btn-light-primary ms-2'
                data-bs-dismiss='modal'
                onClick={() => setShowLedgerDetailsModal(false)}
              >
                <KTIcon className='fs-1' iconName='cross' />
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div className='text-center py-5 px-5 w-50'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Ledger Code</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.ledgerCode ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.ledgerCode ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Parent Ledger</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.parentLedger ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.parentLedger}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Sub Ledger</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.subLedger ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.subLedger ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Parent Group</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.parentGroup ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.parentGroup ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Sub Group</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.subGroup ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.subGroup ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Transaction Type</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.transactionType ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.transactionType ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Opening Balance</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {selectedLedgerDetails?.openingBalance}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>As On Date</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {selectedLedgerDetails?.asOnDate
                      ? new Date(selectedLedgerDetails.asOnDate).toDateString().slice(4)
                      : 'NA'}
                  </span>
                </div>
              </div>
            </div>

            <div className='text-center py-5 px-5 w-50'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Currency</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {selectedLedgerDetails?.currency ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Account Number</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.accountNumber ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.accountNumber ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Branch Name</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.branchName ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.branchName ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Address</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.address ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.address ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>State</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.state ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.state ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Country</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.country ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.country ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Postal Code</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.postalCode ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.postalCode ?? 'NA'}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>IFSC Code</label>
                <div className='col-lg-8'>
                  <span
                    className={`fw-bolder fs-6 text-${
                      selectedLedgerDetails?.ifscCode ? 'dark' : 'danger'
                    }`}
                  >
                    {selectedLedgerDetails?.ifscCode ?? 'NA'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal> */}
      <ViewLedgerModal
        showLedgerDetailsModal={showLedgerDetailsModal}
        setShowLedgerDetailsModal={setShowLedgerDetailsModal}
        selectedLedgerDetails={selectedLedgerDetails}
      />
    </>
  )
}

export default ViewTransactionModal
